import React from 'react'
import styled from '@emotion/styled'
import logoImages from 'src/images/partner/fv_company_logo.png'

export const PartnerClient = () => {
    return (
        <Container>
            <CompanyLogo>
                <LogoImg1 src={logoImages} alt="導入企業ロゴ"></LogoImg1>
                <LogoImg2 src={logoImages} alt="導入企業ロゴ"></LogoImg2>
            </CompanyLogo>
        </Container>
    )
}

const Container = styled.section`
`


const CompanyLogo = styled.dev`
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    width: 100%;
    overflow: hidden;
    height: 100%;
    background: #ffffff;
    padding: 10px 0;
    z-index: 100;
    position: relative;
`

const LogoImg1 = styled.img`
    height: 100px;
    padding-left: 38px;
    -webkit-animation: loop 50s -25s linear infinite;
    animation: loop 50s -25s linear infinite;
    @-webkit-keyframes loop {
        0% {
          -webkit-transform: translateX(100%);
                  transform: translateX(100%);
        }
        100% {
          -webkit-transform: translateX(-100%);
                  transform: translateX(-100%);
        }
      }
      
      @keyframes loop {
        0% {
          -webkit-transform: translateX(100%);
                  transform: translateX(100%);
        }
        100% {
          -webkit-transform: translateX(-100%);
                  transform: translateX(-100%);
        }
      }
`

const LogoImg2 = styled.img`
    height: 100px;
    padding-left: 38px;
    -webkit-animation: loop2 50s linear infinite;
            animation: loop2 50s linear infinite;
            @-webkit-keyframes loop2 {
                0% {
                  -webkit-transform: translateX(0);
                          transform: translateX(0);
                }
                100% {
                  -webkit-transform: translateX(-200%);
                          transform: translateX(-200%);
                }
              }
              
              @keyframes loop2 {
                0% {
                  -webkit-transform: translateX(0);
                          transform: translateX(0);
                }
                100% {
                  -webkit-transform: translateX(-200%);
                          transform: translateX(-200%);
                }
              }
`

